import { MDText } from 'i18n-react';

import ROUTES from 'Utilities/routes';

import LocalTexts from './AccountSettings.texts';

const LocalT = new MDText(LocalTexts);

export enum AccountSettingsSlugs {
	COMPANY_INFORMATION = 'company-information',
	HOME = '',
}

export type MetaDataKeyPage = 'homepage' | 'companyInformation';

export const ACCOUNT_SETTINGS_COMPANY_INFORMATION_LINK = ROUTES.ACCOUNT_SETTINGS.as(
	AccountSettingsSlugs.COMPANY_INFORMATION,
);

export const ACCOUNT_SETTINGS_LINK_TITLE = `${LocalT.translate('titles.accountSettings')}`;
export const COMPANY_INFORMATION_LINK_TEXT = `${LocalT.translate('links.companyInformation')}`;
